import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { http, errMsg } from "@/lib/api";
import { F, inputCls, Card, SaveBar } from "@/components/admin/shared";

const HOUR_KEYS = ["operating_hours", "service_status", "service_status_note", "service_schedules", "slot_interval"];

export const SettingsPanel = ({ categories, section = "profil" }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-sm text-nanina-muted">Memuat...</p>;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const inp = (k, label, hint) => <F label={label} hint={hint}><input className={inputCls} value={s[k] || ""} onChange={set(k)} data-testid={`setting-${k}`} /></F>;
  const area = (k, label) => <F label={label} className="sm:col-span-2"><textarea rows={2} className={inputCls} value={s[k] || ""} onChange={set(k)} data-testid={`setting-${k}`} /></F>;
  const featured = s.featured_category_slugs || [];
  const toggleFeatured = (slug) => setS({ ...s, featured_category_slugs: featured.includes(slug) ? featured.filter((x) => x !== slug) : [...featured, slug] });

  const save = async (publish) => {
    if (!/^62\d{8,13}$/.test(s.whatsapp_number || "")) return toast.error("Nomor WhatsApp harus format 62xxxxxxxxxx.");
    setBusy(true);
    try {
      const body = Object.fromEntries(Object.entries(s).filter(([k]) => !HOUR_KEYS.includes(k)));
      await http.put("/admin/settings", body);
      if (publish) await http.post("/admin/settings/publish");
      const r = await http.get("/admin/settings");
      setS(r.data);
      toast.success(publish ? "Konten website diterbitkan" : "Draft konten disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const profil = section === "profil";
  return (
    <div className="space-y-4 pb-20" data-testid={`settings-panel-${section}`}>
      {profil && <Card title="Hero beranda">
        {inp("hero_eyebrow", "Label kecil")}
        {inp("hero_cta", "Teks tombol utama")}
        {area("hero_title", "Judul utama")}
        {area("hero_description", "Deskripsi")}
        <div className="sm:col-span-2">
          <p className="text-xs font-semibold text-nanina-green">Layanan unggulan di hero</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {categories.map((c) => (
              <button type="button" key={c.id} onClick={() => toggleFeatured(c.slug)} className={`rounded-full px-3 py-1.5 text-xs font-semibold border ${featured.includes(c.slug) ? "bg-nanina-green text-white border-nanina-green" : "bg-white text-nanina-green border-nanina-line"}`} data-testid={`setting-featured-${c.slug}`}>{c.name}</button>
            ))}
          </div>
        </div>
      </Card>}
      {profil && <Card title="Informasi Homecare">
        {area("homecare_radius_text", "Jangkauan layanan")}
        {area("homecare_travel_text", "Ongkos perjalanan")}
        {area("homecare_confirm_text", "Keterangan konfirmasi admin")}
      </Card>}
      {!profil && <Card title="Kontak & lokasi">
        {inp("whatsapp_display", "Nomor WhatsApp (tampilan)")}
        {inp("whatsapp_number", "Nomor WhatsApp (format 62…)", "Dipakai untuk link wa.me")}
        {area("address", "Alamat usaha")}
        {inp("maps_url", "Link Google Maps")}
        {inp("maps_embed_url", "Link embed peta (opsional)", "Dari Google Maps → Bagikan → Sematkan peta → salin src")}
      </Card>}
      {!profil && <Card title="Media sosial">
        {inp("instagram_url", "URL Instagram")}
        {inp("instagram_handle", "Username Instagram")}
        {inp("tiktok_url", "URL TikTok")}
        {inp("tiktok_handle", "Username TikTok")}
        {inp("social_title", "Judul bagian sosial")}
        {inp("social_description", "Deskripsi bagian sosial")}
      </Card>}
      {profil && <Card title="Banner promo">
        <label className="sm:col-span-2 flex items-center gap-2 text-sm text-nanina-green">Tampilkan banner promo <Switch checked={!!s.promo_active} onCheckedChange={(v) => setS({ ...s, promo_active: v })} data-testid="setting-promo_active" /></label>
        {inp("promo_title", "Judul promo")}
        {inp("promo_description", "Keterangan promo")}
      </Card>}
      {profil && <Card title="Privasi">{area("privacy_note", "Catatan privasi formulir")}</Card>}
      <SaveBar busy={busy} s={s} onDraft={() => save(false)} onPublish={() => save(true)} testId="settings" />
    </div>
  );
};
